import { Button, Heading, Text, VStack } from '@masterplandev/ui'

import { CloudImage } from '@/cloud-image/CloudImage'
import useTranslation from '@/core/hooks/useTranslation'
import { linebreak } from '@/core/richTextElements'

export function AIFoundationEnding({ onContinue }: { onContinue: () => void }) {
  const { translate } = useTranslation('ai-foundations-ending')

  return (
    <VStack spacing="6">
      <div>
        <CloudImage
          imageId="system/ai-foundations-post-poll"
          options={{ fit: 'cover', width: 476 }}
          width="476px"
          height="286px"
        />
      </div>
      <Heading size={['h4', 'h3']}>{translate('title')}</Heading>
      <Text
        textAlign="center"
        color="mp2.neutralDark.800"
        size={['default', 'big']}>
        {translate('text', { linebreak })}
      </Text>
      <Button size="lg" onClick={onContinue}>
        {translate('continue')}
      </Button>
    </VStack>
  )
}
